import { render, staticRenderFns } from "./LegoCardPayloadTable.vue?vue&type=template&id=77136048&scoped=true&"
import script from "./LegoCardPayloadTable.vue?vue&type=script&lang=ts&"
export * from "./LegoCardPayloadTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77136048",
  null
  
)

export default component.exports